<script setup lang="ts">
import {ref, useTemplateRef} from "vue";
import {PageLoading, PageTitle} from "@/Components/Global";
import {getStimulus} from "@/Services/stimuli";
import StimulusDisplay from "./StimulusDisplay.vue";
import {Button, Menu} from "@/Components/Library";
import {useRouter} from "vue-router";

const router = useRouter();
console.log(router.currentRoute.value);
const stimulus = ref();
getStimulus(router.currentRoute.value.params.stimulus).then((data) => {
    stimulus.value = data;
});
const stimulusMenuContainer = useTemplateRef("stimulusMenuContainer");
const groupMenuItems = ref([
    {
        label: "Edit",
        icon: "prime:pencil",
        command: () => {
            router.push({name: "stimuli.edit", params: {stimulus: stimulus.value.id}});
        },
    },
]);
</script>
<template>
    <div class="mx-auto max-w-5xl">
        <div class="m-container mb-3">
            <PageTitle title="Stimulus">
                <Button
                    :icon="{
                        icon: 'pepicons-pencil:dots-y',
                        width: '24',
                    }"
                    class="ml-auto !ring-0"
                    @click.stop="stimulusMenuContainer?.menu?.toggle($event)"
                />
            </PageTitle>
            <Menu ref="stimulusMenuContainer" :popup="true" :model="groupMenuItems" />
        </div>
        <div v-if="stimulus">
            <div class="m-container mb-3 rounded-lg">
                <div class="mb-4">
                    <p class="text-xs font-bold uppercase">{{ stimulus.type.name }}</p>
                    <h2 class="mb-2 break-words text-2xl font-bold">{{ stimulus.title }}</h2>
                    <!--                    <TagList :tags="stimulus.tags" class="mb-2" />-->
                    <div v-if="stimulus.description">
                        <h4 class="font-bold">Description</h4>
                        <p class="mb-2 break-words">{{ stimulus.description }}</p>
                    </div>
                </div>
                <StimulusDisplay :stimulus="stimulus" />
            </div>
        </div>
        <div v-else>
            <PageLoading />
        </div>
    </div>
</template>
<style scoped></style>
